import React from 'react';
import { LogOut, X } from 'lucide-react';

interface LogoutModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title: string;
  subtitle: string;
  description: string;
  confirmText: string;
  cancelText: string;
}

const LogoutModal: React.FC<LogoutModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  title,
  subtitle,
  description,
  confirmText,
  cancelText,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[9999] flex items-end lg:items-center justify-center p-4 pb-24 lg:pb-4 animate-in fade-in duration-300">
      <div className="bg-white rounded-[32px] lg:rounded-[40px] w-full lg:max-w-md shadow-2xl animate-in slide-in-from-bottom-4 lg:zoom-in-95 duration-300 max-h-[calc(100vh-140px)] lg:max-h-none overflow-y-auto">
        {/* Header */}
        <div className="px-6 lg:px-8 pt-8 lg:pt-10 pb-6 border-b border-black/5 flex items-start justify-between">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 lg:w-14 lg:h-14 rounded-2xl lg:rounded-3xl bg-rose-50 flex items-center justify-center">
              <LogOut size={24} className="text-rose-600 lg:w-7 lg:h-7" />
            </div>
            <div>
              <h2 className="text-[18px] lg:text-xl font-black text-black">{title}</h2>
              <p className="text-[11px] lg:text-xs text-black/40 font-medium mt-1">{subtitle}</p>
            </div>
          </div>
          <button
            onClick={onCancel}
            className="p-2 hover:bg-gray-100 rounded-xl transition-colors shrink-0"
          >
            <X size={20} className="text-black/40" />
          </button>
        </div>

        {/* Content */}
        <div className="px-6 lg:px-8 py-6 lg:py-8">
          <p className="text-[13px] lg:text-sm text-black/60 leading-relaxed font-medium">
            {description}
          </p>
        </div>

        {/* Actions */}
        <div className="px-6 lg:px-8 pb-6 lg:pb-8 flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 h-12 lg:h-14 rounded-[18px] lg:rounded-[22px] bg-gray-50 text-black font-black text-[11px] lg:text-xs uppercase tracking-wider border border-black/5 active:scale-95 transition-all duration-200 hover:bg-gray-100"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 h-12 lg:h-14 rounded-[18px] lg:rounded-[22px] bg-rose-600 text-white font-black text-[11px] lg:text-xs uppercase tracking-wider active:scale-95 transition-all duration-200 hover:bg-rose-700 shadow-lg shadow-rose-600/30"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
